(function () {
  'use strict';

  function initMomSection(track) {
    var sectionId = track.id.replace('mom-cards-', '');
    var dotsWrap  = document.getElementById('mom-dots-' + sectionId);
    var section   = document.getElementById('section-mom-' + sectionId) || track;

    var AUTOPLAY = track.dataset.autoplay === 'true';
    var INTERVAL = parseInt(track.dataset.interval, 10) || 3000;
    var TOTAL    = parseInt(track.dataset.total, 10) || 3;

    var COPIES   = 3;          // 1 2 3 | 1 2 3 | 1 2 3
    var MIDDLE   = 1;          // start in the middle copy (0-indexed)
    var currentIndex  = 0;     // real slide index 0..TOTAL-1
    var timer         = null;
    var isMobile      = window.innerWidth <= 768;
    var isTeleporting = false;
    var scrollTimeout = null;

    /* ── TOUCH ROUTING: the browser decides axis from touch-action.
          Force the track to allow BOTH axes so a vertical swipe that
          starts on a card scrolls the page, while a horizontal swipe
          scrolls the carousel. This is the real fix for "can't scroll
          up/down on mobile". ── */
    function ensureTouchAction() {
      track.style.touchAction = 'pan-x pan-y';
    }

    /* ── VIDEO: load + play only. CSS keeps video permanently
          on top of its poster, so there is nothing to "reveal". ── */
    function safePlay(video) {
      if (!video) return;
      if (!video.paused && !video.ended) return;
      video.play().catch(function() {});
    }

    function loadAndPlayAll() {
      track.querySelectorAll('.mom-card__video').forEach(function(video) {
        video.muted = true;
        video.preload = 'auto';
        safePlay(video);
      });
    }

    function playAllVideos()    { loadAndPlayAll(); }
    function preloadAllVideos() { loadAndPlayAll(); }

    /* ── AUTO-RESUME GUARD: outside scripts (variant pickers, swatch
          clicks, Prestige product-rerender, quick-view apps) morph the
          DOM and pause our videos. We resume any video that gets paused
          for any reason other than the tab being hidden. ── */
    var resumeTimer = null;
    function resumeSoon() {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function() {
        if (document.hidden) return;
        keepPlaying();
      }, 120);
    }

    // 'pause' does not bubble, but it CAN be caught in the capture phase.
    section.addEventListener('pause', function(e) {
      var v = e.target;
      if (!v || !v.classList || !v.classList.contains('mom-card__video')) return;
      if (document.hidden || v.ended) return;
      resumeSoon();
    }, true);

    // Any click anywhere (image, variant, swatch, buttons) → re-assert play.
    document.addEventListener('click', resumeSoon, true);
    document.addEventListener('pointerup', resumeSoon, { capture: true, passive: true });

    // Prestige dispatches variant/cart events on documentElement.
    ['variant:changed', 'variant:change', 'product:rerender', 'change'].forEach(function(evt) {
      document.documentElement.addEventListener(evt, resumeSoon, { capture: true, passive: true });
    });

    // If a theme/app script morphs nodes inside the section, re-play.
    var mo = new MutationObserver(function() {
      resumeSoon();
    });
    mo.observe(section, { childList: true, subtree: true });

    /* ── METRICS ── */
    function getMetrics() {
      var cards = track.querySelectorAll('.mom-card');
      if (!cards.length) return null;
      var cardW = cards[0].offsetWidth;
      var gap   = parseFloat(getComputedStyle(track).columnGap) || 0;
      return { cardW: cardW, gap: gap };
    }

    function rawIndexOf(copy, slide) {
      return copy * TOTAL + slide;
    }

    function scrollToRaw(rawIdx, smooth) {
      var m = getMetrics();
      if (!m) return;
      var target = rawIdx * (m.cardW + m.gap);
      if (smooth) {
        track.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        track.scrollLeft = target;
      }
    }

    /* ── BUILD TRIPLE STRIP: duplicate the real cards (COPIES-1) more
          times so the strip is 1 2 3 1 2 3 1 2 3. Every card the user
          lands on is a full, already-loaded duplicate — no clone resets,
          no edge to flicker across. ── */
    function buildStrip() {
      // Remove any previously-added duplicates.
      track.querySelectorAll('.mom-card.is-dup').forEach(function(c) { c.remove(); });

      var realCards = Array.from(track.querySelectorAll('.mom-card:not(.is-dup)'));
      if (!realCards.length) return;

      function makeDup(card) {
        var dup = card.cloneNode(true);
        dup.classList.add('is-dup');
        dup.setAttribute('aria-hidden', 'true');
        dup.removeAttribute('data-shopify-editor-block');

        dup.querySelectorAll('img').forEach(function(img) {
          img.loading = 'eager';
          img.decoding = 'sync';
        });
        dup.querySelectorAll('.mom-card__video').forEach(function(v) {
          v.muted = true;
          v.preload = 'auto';
          safePlay(v);
        });
        return dup;
      }

      // Append (COPIES - 1) extra full copies after the originals.
      for (var c = 1; c < COPIES; c++) {
        realCards.forEach(function(card) {
          track.appendChild(makeDup(card));
        });
      }
    }

    /* ── keep everything playing (no reveal) ── */
    function keepPlaying() {
      track.querySelectorAll('.mom-card__video').forEach(safePlay);
    }

    /* ── DOTS ── */
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < TOTAL; i++) {
        var dot = document.createElement('button');
        dot.className = 'mom-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots(realIdx) {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.mom-dot')
        .forEach(function(d, i) { d.classList.toggle('is-active', i === realIdx); });
    }

    /* ── AUTO-SLIDE: advance within the middle copy. When we step past
          the last real slide, jump forward one slide (into the next copy)
          smoothly, then silently snap back by one whole copy. The target
          card is identical & already loaded → invisible. ── */
    var virtualSlide = 0; // 0..TOTAL-1 within current visible run

    function next() {
      if (!isMobile || isTeleporting) return;

      virtualSlide++;
      var realIdx = virtualSlide % TOTAL;
      currentIndex = realIdx;
      updateDots(realIdx);

      // Raw position = middle copy start + how far we've stepped.
      var rawIdx = rawIndexOf(MIDDLE, 0) + virtualSlide;
      scrollToRaw(rawIdx, true);
      keepPlaying();

      // If we've walked a full copy past the middle, snap back one copy.
      if (virtualSlide >= TOTAL) {
        isTeleporting = true;
        setTimeout(function() {
          virtualSlide = virtualSlide - TOTAL;
          scrollToRaw(rawIndexOf(MIDDLE, 0) + virtualSlide, false);
          isTeleporting = false;
          keepPlaying();
        }, 620);
      }
    }

    function startAutoplay() {
      if (!AUTOPLAY || !isMobile) return;
      stopAutoplay();
      timer = setInterval(next, INTERVAL);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    /* ── SCROLL: keep dots in sync, keep videos playing ── */
    function onScroll() {
      if (!isMobile) return;
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var m = getMetrics();
        if (!m) return;
        var rawIdx = Math.round(track.scrollLeft / (m.cardW + m.gap));
        var realIdx = ((rawIdx % TOTAL) + TOTAL) % TOTAL;
        if (realIdx !== currentIndex && !isTeleporting) {
          currentIndex = realIdx;
          updateDots(realIdx);
        }
        keepPlaying();
      }, 50);
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    /* ── PAUSE AUTOPLAY WHILE THE USER IS TOUCHING ──
          Also re-asserts touch-action on every touchstart in case a
          re-render or theme script reset it. Listeners are passive so
          they never block the page's own scrolling. ── */
    track.addEventListener('touchstart', function() {
      ensureTouchAction();
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function() {
      if (isMobile && AUTOPLAY) startAutoplay();
      resumeSoon();
    }, { passive: true });

    track.addEventListener('touchcancel', function() {
      if (isMobile && AUTOPLAY) startAutoplay();
      resumeSoon();
    }, { passive: true });

    /* ── VISIBILITY ── */
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        playAllVideos();
        if (isMobile && AUTOPLAY) startAutoplay();
      }
    });

    /* ── RESIZE ── */
    var resizeTimer = null;
    window.addEventListener('resize', function() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var wasMobile = isMobile;
        isMobile = window.innerWidth <= 768;

        if (isMobile && !wasMobile) {
          ensureTouchAction();
          buildStrip();
          buildDots();
          virtualSlide = 0;
          currentIndex = 0;
          requestAnimationFrame(function() {
            scrollToRaw(rawIndexOf(MIDDLE, 0), false);
            updateDots(0);
            preloadAllVideos();
            keepPlaying();
            if (AUTOPLAY) startAutoplay();
          });
        } else if (!isMobile && wasMobile) {
          stopAutoplay();
          track.querySelectorAll('.mom-card.is-dup').forEach(function(c) { c.remove(); });
          if (dotsWrap) dotsWrap.innerHTML = '';
          track.scrollLeft = 0;
          playAllVideos();
        }
      }, 150);
    }, { passive: true });

    /* ── INIT ── */
    ensureTouchAction();

    if (isMobile) {
      loadAndPlayAll();
      buildStrip();
      buildDots();

      // Start centered on the first slide of the MIDDLE copy.
      requestAnimationFrame(function() {
        scrollToRaw(rawIndexOf(MIDDLE, 0), false);
        virtualSlide = 0;
        currentIndex = 0;
        updateDots(0);
        keepPlaying();
        if (AUTOPLAY) startAutoplay();
      });

    } else {
      if (document.readyState === 'complete') {
        playAllVideos();
      } else {
        window.addEventListener('load', playAllVideos, { once: true });
      }
    }
  }

  function boot() {
    document.querySelectorAll('[id^="mom-cards-"]').forEach(function(track) {
      initMomSection(track);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();